module.exports = __webpack_public_path__ + "img/1.62803b79.png";